import { SimpleModel } from '@/models/base/SimpleModel';

export class Customer extends SimpleModel {
  constructor(init?: Partial<Customer>) {
    super();
    Object.assign(this, init);
  }
}
